<template>
	<div class="input-captcha">
		<div class="image-holder" @click.prevent="load">
			<loader :loading="loading"></loader>
			<transition name="fade">
				<img :src="img" v-if="img && !loading" />
			</transition>
			<div class="overlay">
				<icon icon="arrows/cycle/reset"></icon>
			</div>
		</div>
		<input-text v-model="captcha" :label="label" :errors="errors"></input-text>
	</div>
</template>

<script>
	export default {
		props: ['value', 'name', 'errors', 'label'],
		data() {
			return {
				loading: false,
				img: null,
				captcha: this.value
			};
		},
		watch: {
			value() {
				this.captcha = this.value;
			},
			captcha() {
				this.$emit('input', this.captcha);
			}
		},
		methods: {
			async reset() {
				await this.load();
			},
			async load() {
				this.loading = true;
				try {
					const data = await this.$get('/json/captcha/' + this.name);
					this.img = data.captcha;
				} catch(e) {}
				this.loading = false;
			}
		},
		async mounted() {
			await this.load();
		}
	}
</script>